import { BsGithub, BsLinkedin } from 'react-icons/bs'

export default function Footer() {
    return (
        <div className='flex justify-center items-center'>
            <a href="https://github.com/Adamtpacz"><BsGithub className='h-16 w-16 m-4 bg-accent hover:bg-accent-focus rounded-full transition ease-in-out hover:scale-110 duration-200' /></a>
            <div className='text-center'>
                <p>Email me at:</p>
                <p>adamtpacz@gmail.com</p>
            </div>
            <a href="https://www.linkedin.com/in/adam-paczkowski/"><BsLinkedin className='h-16 w-16 m-4 bg-accent hover:bg-accent-focus rounded-lg transition ease-in-out hover:scale-110 duration-200' /></a>
        </div>
    )
}